export default {"src":"/_next/static/media/guarantee.14082693.svg","height":49,"width":57,"blurWidth":0,"blurHeight":0};